import axios from '../../http'
import { handleGetRequestParams } from '../../common/js/util'

class DBOrder {
  // 出库审核
  reviewOutOfStore(data) {
    const url = `/api/db/order/warehouse/examine`
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data)
    })
  }
  // 获取快递公司列表
  getLogisList() {
    const url = `/api/common/express/list`
    return axios.get(url).then(res => {
      return Promise.resolve(res.data)
    })
  }
  // db修改xb已有的订单
  updateOrder(data) {
    const url = `/api/db/order/modify`
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data)
    })
  }
  // db给xb创建订单
  createNewOrder(data) {
    const url = `/api/db/order/create`
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data)
    })
  }
  // db给xb创建返修单
  createNewRepairOrder(data) {
    const url = `/api/db/repair/save`
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data)
    })
  }
  // 返修单送修
  repairOut(data) {
    const url = `/api/db/repair/out`
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data)
    })
  }
  // 返修单收货
  repairReceive(data) {
    const url = `/api/db/repair/receive`
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data)
    })
  }
  // 返修单打印
  repairPrint(data) {
    const url = `/api/db/repair/print`
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data)
    })
  }
  // 大B--订单列表
  getDBOrderList(options) {
    let url = '/api/db/order/list?'
    url += handleGetRequestParams(options)
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // 根据code获取订单详情
  getDBOrderDetailByCode(orderCode) {
    const url = `/api/db/order/detail?orderCode=${orderCode}`
    return axios.get(url).then(res => {
      return Promise.resolve(res.data)
    })
  }
  // 根据code获取订单物流详情
  getDBLogisDetailByCode(orderCode) {
    const url = `/api/db/order/express/detail?orderCode=${orderCode}`
    return axios.get(url).then(res => {
      return Promise.resolve(res.data)
    })
  }
  // 根据code--订单审核
  checkOrder(data) {
    const url = `/api/db/order/examine`
    console.log('参数', data)
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data)
    })
  }
  // 根据code--财务审核
  checkFinance(data) {
    const url = `/api/db/order/payment/examine`
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data)
    })
  }
  // 根据code--出库审核
  checkOutStore(data) {
    const url = `/api/db/order/warehouse/examine`
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data)
    })
  }
  // 根据code--发货确认
  confirmShip(data) {
    const url = `/api/db/order/express/comfirm`
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data)
    })
  }
  // DB获取退货单列表
  getDBRefundList(searchCode, startTime, endTime, xbName, status, currentPage) {
    let url
    if (((searchCode || startTime || endTime || xbName) || currentPage > 1 || status >= 0)) {
      url = `/api/db/refund/list?searchCode=${searchCode}&startTime=${startTime}&endTime=${endTime}&xbName=${xbName}&status=${status}&currentPage=${currentPage}`
    } else {
      url = '/api/db/refund/list'
    }
    return axios.get(url).then(res => {
      return Promise.resolve(res.data)
    })
  }
  // DB查看退货详情
  getDBRefundDetail(refundCode) {
    let url = '/api/db/refund/detail?refundCode=' + refundCode
    return axios.get(url).then(res => {
      return Promise.resolve(res.data)
    })
  }
  // DB退货审核
  postDBRefundExaminel(refundCode, res) {
    let url = '/api/db/refund/examine'
    let data = {
      refundCode,
      res
    }
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data)
    })
  }
  // DB修改退货单
  postDBRefundModify(refundCode, refundDetailList, realRefundMoney, refundAddress) {
    let url = '/api/db/refund/modify'
    let data = {
      refundCode,
      refundDetailList,
      realRefundMoney,
      refundAddress
    }
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data)
    })
  }
  // DB退货 收货确认
  postDBRefundReceive(refundCode) {
    let url = '/api/db/refund/goods/receive'
    let data = {
      refundCode
    }
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data)
    })
  }
  // DB退款确认
  postDBRefundMoney(refundCode) {
    let url = '/api/db/refund/money/return'
    let data = {
      refundCode
    }
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data)
    })
  }
  // DB农行发起退款
  getDBEBankRefund(refundCode) {
    let url = `/api/db/refund/bank/refund?refundCode=${refundCode}`
    return axios.get(url).then(res => {
      return Promise.resolve(res.data)
    })
  }
  // 根据退货单获取物流详情
  getDBLogisDetailByRefundCode(refundCode) {
    const url = `/api/db/refund/express/detail?refundCode=${refundCode}`
    return axios.get(url).then(res => {
      return Promise.resolve(res.data)
    })
  }
  //新建订单-查询客户地址
  getAddressList(xbId) {
    const url = `/api/db/order/address/list?xbId=${xbId}`
    return axios.get(url).then(res => {
      return Promise.resolve(res.data)
    })
  }
  //新建订单-添加客户地址
  postAddAddress(data) {
    const url = `/api/db/order/address/add`
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data)
    })
  }
  //新建订单-删除客户地址
  postDeleteAddress(data) {
    const url = `/api/db/order/address/del`
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data)
    })
  }
  //新建订单-修改客户地址
  postUpdateAddAddress(data) {
    const url = `/api/db/order/address/update`
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data)
    })
  }
  //选品单列表
  getSelectionOrderList(options) {
    let url = `/api/db/selection/list?`
    url += handleGetRequestParams(options)
    return axios.get(url).then(res => {
      return Promise.resolve(res.data)
    })
  }
  //返修单列表
  getRepairList(options) {
    let url = `/api/db/repair/list?`
    url += handleGetRequestParams(options)
    return axios.get(url).then(res => {
      return Promise.resolve(res.data)
    })
  }
  //添加付款记录
  setPaymentRecords(data) {
    let url = `/api/db/order/collect/add`
    return axios.post(url,data).then(res => {
      return Promise.resolve(res.data)
    })
  }
  //付款列表
  getPaymentRecordsList(orderCode) {
    let url = `/api/db/order/collect/list?orderCode=${orderCode}`
    return axios.get(url).then(res => {
      return Promise.resolve(res.data)
    })
  }
  //获取账号信息
  getBank() {
    let url = `/api/back/pay/underline/get/request`
    return axios.get(url).then(res => {
      return Promise.resolve(res.data)
    })
  }
  // 作废订单
  postVoidOrder(data) {
    let url = `/api/db/order/invalid`
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data)
    })
  }
  // 操作日志
  getOperationLogList(orderCode) {
    let url = `/api/db/order/operate/history/list?orderCode=${orderCode}`
    return axios.get(url).then(res => {
      return Promise.resolve(res.data)
    })
  }
  // 修改订单地址
  modOrderAddress(data) {
    let url = `/api/db/order/modify/address`
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data)
    })
  }
}

export default DBOrder
